import {Catalog} from '../../../../common/types/common';
import {BankTarget} from '../types';

export class CalculatorStepViewFieldErrorState {
    yearFieldError: string;
    brandFieldError: string;
    modelFieldError: string;
    versionFieldError: string;
    provinceFieldError: string;
    postalCodeFieldError: string;
    priceFieldError: string;
    downPaymentFieldError: string;
    monthlyPaymentFieldError: string;
    postalCodeIsValid: boolean;

    constructor(yearFieldError: string = null,
                brandFieldError: string = null,
                modelFieldError: string = null,
                versionFieldError: string = null,
                provinceFieldError: string = null,
                postalCodeFieldError: string = null,
                priceFieldError: string = null,
                downPaymentFieldError: string = null,
                monthlyPaymentFieldError: string = null,
                postalCodeIsValid: boolean = false) {
        this.yearFieldError = yearFieldError;
        this.brandFieldError = brandFieldError;
        this.modelFieldError = modelFieldError;
        this.versionFieldError = versionFieldError;
        this.provinceFieldError = provinceFieldError;
        this.postalCodeFieldError = postalCodeFieldError;
        this.priceFieldError = priceFieldError;
        this.downPaymentFieldError = downPaymentFieldError;
        this.monthlyPaymentFieldError = monthlyPaymentFieldError;
        this.postalCodeIsValid = postalCodeIsValid;
    }
}

export class PersonalDataStepViewFieldErrorState {
    firstNameFieldError: string;
    secondNameFieldError: string;
    lastNameFieldError: string;
    secondLastNameFieldError: string;
    birthDateFieldError: string;
    docNumberFieldError: string;
    cellPhoneFieldError: string;
    genderFieldError: string;
    civilStatusFieldError: string;
    studiesLevelFieldError: string;
    economicDependentsFieldError: string;
    alreadyHasVehicleFieldError: string;
    nationalityFieldError: string;

    constructor(firstNameFieldError: string = null,
                secondNameFieldError: string = null,
                lastNameFieldError: string = null,
                secondLastNameFieldError: string = null,
                birthDateFieldError: string = null,
                docNumberFieldError: string = null,
                cellPhoneFieldError: string = null,
                genderFieldError: string = null,
                civilStatusFieldError: string = null,
                studiesLevelFieldError: string = null,
                economicDependentsFieldError: string = null,
                alreadyHasVehicleFieldError: string = null,
                nationalityFieldError: string = null) {
        this.firstNameFieldError = firstNameFieldError;
        this.secondNameFieldError = secondNameFieldError;
        this.lastNameFieldError = lastNameFieldError;
        this.secondLastNameFieldError = secondLastNameFieldError;
        this.birthDateFieldError = birthDateFieldError;
        this.docNumberFieldError = docNumberFieldError;
        this.cellPhoneFieldError = cellPhoneFieldError;
        this.genderFieldError = genderFieldError;
        this.civilStatusFieldError = civilStatusFieldError;
        this.studiesLevelFieldError = studiesLevelFieldError;
        this.economicDependentsFieldError = economicDependentsFieldError;
        this.alreadyHasVehicleFieldError = alreadyHasVehicleFieldError;
        this.nationalityFieldError = nationalityFieldError;
    }
}

export interface CalculatorStepViewState {
    fieldErrors: CalculatorStepViewFieldErrorState;
}

export interface PersonalDataStepViewState {
    fieldErrors: PersonalDataStepViewFieldErrorState;
}

export interface BureauValidateNipViewState {
    hasNipValidationError: boolean;
}

export class WorkDataStepViewErrorFieldState {
    workplaceNameFieldError: string;
    positionFieldError: string;
    workingSinceFieldError: string;
    addressFieldError: string;
    extNumberFieldError: string;
    intNumberFieldError: string;
    postalCodeFieldError: string;
    stateFieldError: string;
    cityFieldError: string;
    municipalityFieldError: string;
    selectedColonyFieldError: string;
    workplacePhoneFieldError: string;
    monthlyIncomesFieldError: string;
    relationshipTypeIdFieldError: string;
    documentTypeFieldError: string;
    businessTypeFieldError: string;
    billingTypeFieldError: string;
    taxRegimeFieldError: string;

    constructor(workplaceNameFieldError: string = null,
                positionFieldError: string = null,
                workingSinceFieldError: string = null,
                addressFieldError: string = null,
                extNumberFieldError: string = null,
                intNumberFieldError: string = null,
                postalCodeFieldError: string = null,
                stateFieldError: string = null,
                cityFieldError: string = null,
                municipalityFieldError: string = null,
                selectedColonyFieldError: string = null,
                workplacePhoneFieldError: string = null,
                monthlyIncomesFieldError: string = null,
                relationshipTypeIdFieldError: string = null,
                documentTypeFieldError: string = null,
                businessTypeFieldError: string = null,
                billingTypeFieldError: string = null,
                taxRegimeFieldError: string = null,
    ) {
        this.workplaceNameFieldError = workplaceNameFieldError;
        this.positionFieldError = positionFieldError;
        this.workingSinceFieldError = workingSinceFieldError;
        this.addressFieldError = addressFieldError;
        this.postalCodeFieldError = postalCodeFieldError;
        this.stateFieldError = stateFieldError;
        this.cityFieldError = cityFieldError;
        this.municipalityFieldError = municipalityFieldError;
        this.selectedColonyFieldError = selectedColonyFieldError;
        this.workplacePhoneFieldError = workplacePhoneFieldError;
        this.monthlyIncomesFieldError = monthlyIncomesFieldError;
        this.relationshipTypeIdFieldError = relationshipTypeIdFieldError;
        this.extNumberFieldError = extNumberFieldError;
        this.documentTypeFieldError = documentTypeFieldError;
        this.businessTypeFieldError = businessTypeFieldError;
        this.billingTypeFieldError = billingTypeFieldError;
        this.taxRegimeFieldError = taxRegimeFieldError;
    }

}

export interface WorkDataStepViewState {
    hasPostalCodeError: boolean;
    fieldErrors: WorkDataStepViewErrorFieldState;
}

export interface BureauAskForNipViewState {
    bureauAlreadyValidated: boolean;
    bureauAlreadyFailed: boolean;
}

export class HomeDataStepViewFieldErrorState {
    addressFieldError: string;
    extNumberFieldError: string;
    intNumberFieldError: string;
    postalCodeFieldError: string;
    stateFieldError: string;
    cityFieldError: string;
    municipalityFieldError: string;
    selectedColonyFieldError: string;
    phoneFieldError: string;
    houseHoldMeasureFieldError: string;
    houseHoldTimeFieldError: string;
    houseTypeFieldError: string;

    constructor(addressFieldError: string = null,
                extNumberFieldError: string = null,
                intNumberFieldError: string = null,
                postalCodeFieldError: string = null,
                stateFieldError: string = null,
                cityFieldError: string = null,
                municipalityFieldError: string = null,
                selectedColonyFieldError: string = null,
                phoneFieldError: string = null,
                houseHoldMeasureFieldError: string = null,
                houseHoldTimeFieldError: string = null,
                houseTypeFieldError: string = null) {
        this.addressFieldError = addressFieldError;
        this.extNumberFieldError = extNumberFieldError;
        this.intNumberFieldError = intNumberFieldError;
        this.postalCodeFieldError = postalCodeFieldError;
        this.stateFieldError = stateFieldError;
        this.cityFieldError = cityFieldError;
        this.municipalityFieldError = municipalityFieldError;
        this.selectedColonyFieldError = selectedColonyFieldError;
        this.phoneFieldError = phoneFieldError;
        this.houseHoldMeasureFieldError = houseHoldMeasureFieldError;
        this.houseHoldTimeFieldError = houseHoldTimeFieldError;
        this.houseTypeFieldError = houseTypeFieldError;
    }
}

export interface HomeDataStepViewState {
    hasPostalCodeError: boolean;
    fieldErrors: HomeDataStepViewFieldErrorState;
}

export interface SummaryStepViewState {
    returnToSummary: boolean;
}

export interface InsuranceIncludesOptionsState {
    id: string;
    value: any;
    label: string;
}

export interface InsuranceDataStepViewState {
    hasInsuranceError: boolean;
    insuranceIncludesOptions: InsuranceIncludesOptionsState[];
}

export interface MonthlyPaymentState {

}

export interface CalculatorState {
    price: string;
    downPayment: string;
    months: number;
    quotas: any;
    monthlyPayment: MonthlyPaymentState;
    hasInsurance: boolean;
    failInsurance: boolean;
    bank: BankTarget;
    queryStringPrice: number;
    queryStringDownPayment: number;
    isUrlFromPI: boolean;
    brandSelected: Catalog;
    modelSelected: Catalog;
    versionSelected: Catalog;
    yearSelected: Catalog;
    provinceSelected: Catalog;
    assemblyCountrySelected: Catalog;
    postalCode: string;
}

export interface ApplicantHomeState {
    address: string;
    extNumber: string;
    intNumber: string;
    postalCode: string;
    state: Catalog;
    city: Catalog;
    municipality: Catalog;
    colonies: Catalog[];
    selectedColony: Catalog;
    phone: string;
    houseHoldMeasure: Catalog;
    houseHoldTime: Catalog;
    houseType: Catalog;
}

export interface ApplicantPersonalState {
    firstName: string;
    secondName: string;
    lastName: string;
    secondLastName: string;
    birthDate: string;
    docNumber: string;
    cellPhone: string;
    email: string;
    gender: Catalog;
    civilStatus: Catalog;
    studiesLevel: Catalog;
    economicDependents: string;
    alreadyHasVehicle: Catalog;
    nationality: Catalog;
}

export interface ApplicantEmploymentState {
    workplaceName: string;
    position: string;
    workingSince: string;
    address: string;
    extNumber: string;
    intNumber: string;
    postalCode: string;
    state: Catalog;
    city: Catalog;
    municipality: Catalog;
    colonies: Catalog[];
    selectedColony: Catalog;
    workplacePhone: string;
    workplacePhoneExt: string;
    includeMonthlyIncomes: boolean;
    monthlyIncomes: string;
    employmentRelationshipTypeId: string;
    documentType: Catalog;
    businessType: Catalog;
    billingTypeId: string;
    taxRegimeId: string;
    billingDocumentId: string;
}

export interface ReferenceState {
    phone: string;
    firstName: string;
    lastName: string;
    secondLastName: string;
}

export interface NIPState {
    identityBureau: string;
    skip: boolean;
}

export interface CreditHistoryState {
    bureauOption: Catalog[];
    bureauOptionCreditCardLastDigits: string;
}

export interface InsuranceSelectedState {
    target: string;
    insuranceType: string;
    insuranceAmount: number;
}

export interface InsuranceState {
    includeInsurance: boolean;
    insuranceSelected: InsuranceSelectedState;
    failInsurance: boolean;
}

export interface SummaryState {
    desiredVehicle: string;
    price: string;
    downPayment: string;
    term: string;
    amountFinance: string;
    detailCommission: string;
    monthlyPayment: string;
    monthlyInsurance: string;
}

export interface FileState {
}

export interface HomeFileState {
    homeFiles: FileState[];
}

export interface WorkFileState {
    billingFiles: FileState[];
}
export interface OtherFileState {
    otherMonthFiles: FileState[][];
}

export interface IdentificationFileState {
    ifeFrontFiles: FileState[];
    ifeBackFiles: FileState[];
}

export interface FilesState {
    identification: IdentificationFileState;
    home: HomeFileState;
    work: WorkFileState;
    other: OtherFileState;
}

export interface CreditoRealUIState {
    summaryStepView: SummaryStepViewState;
    personalDataStepView: PersonalDataStepViewState;
    calculatorStepView: CalculatorStepViewState;
    bureauValidateNipView: BureauValidateNipViewState;
    homeDataStepView: HomeDataStepViewState;
    bureauAskForNipView: BureauAskForNipViewState;
    workDataStepView: WorkDataStepViewState;
    insuranceDataStepView: InsuranceDataStepViewState;
}

export interface CreditoRealLoanApplicationState {
    currentStep: number;
    highestStep: number;
    applicantPersonal: ApplicantPersonalState;
    applicantHome: ApplicantHomeState;
    applicantEmployment: ApplicantEmploymentState;
    otherReferences: ReferenceState[];
    acceptTerms: boolean;
    receiveNewsPromotions: boolean;
    nip: NIPState;
    creditHistory: CreditHistoryState;
    insurance: InsuranceState;
    marketingSource: Catalog;
    token: string;
    createdAt: string;
    summary: SummaryState;
    files: FilesState;
}
